import { render, staticRenderFns } from "./visitasUsers.vue?vue&type=template&id=2ff205ee&scoped=true"
import script from "./visitasUsers.vue?vue&type=script&lang=js"
export * from "./visitasUsers.vue?vue&type=script&lang=js"
import style0 from "./visitasUsers.vue?vue&type=style&index=0&id=2ff205ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff205ee",
  null
  
)

export default component.exports